'use es6';

import { UPDATE_RECAPTCHA_TOKEN, UPDATE_RECAPTCHA_WIDGET_ID } from '../actions/ActionTypes';
var initialState = {
  widgetId: null,
  token: null
};
export default function recaptcha() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case UPDATE_RECAPTCHA_WIDGET_ID:
      return Object.assign({}, state, {
        widgetId: action.payload
      });

    case UPDATE_RECAPTCHA_TOKEN:
      return Object.assign({}, state, {
        token: action.payload
      });

    default:
      return state;
  }
}